<template>
	<div class="gameover_game">
		<cIndex></cIndex>
		<div class="gameover">
			<div class="gameover-content"></div>
			<div class="gameover-button">
				<router-link :to="{path:'/gamelist',query:{id:1}}">返回首页测试</router-link>
				<a class="gameover-button-on" @click="carryGame">继续测试</a>
			</div>
		</div>
	</div>
</template>
<style>
	.gameover{
		width: 100%;
		height: 100%;
		background: #fff;
	}
	.gameover-content{
		width: 967px;
		height: 445px;
		background: #bbb;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
	.gameover-button{
		position: absolute;
		bottom: 135px;
		left: 50%;
		transform: translate(-50%,0);
	}
	.gameover-button a{
		display: inline-block;
		width: 120px;
		height: 35px;
		background: #bbb;
		color: #fff;
		text-align: center;
		line-height: 35px;
		margin: 0 15px;
	}
	.gameover-button .gameover-button-on{
		background: #467DE5;
		cursor: pointer;
	}
</style>
<script>
import cIndex from '@/components/header'
const components ={
	cIndex
}
	export default {
		components:components,
		methods:{
			carryGame() {
				this.$http.post(urls.urltest + "/game/getNextGame.json",{
					token:localStorage.getItem('token'),
					eid:localStorage.getItem('eid')
				}).then(function(res){
					if(!res.body ==''){
						console.log(res.body)
					    window.location.href= res.body;
					}else{
						this.$router.push('/gamelist')
					}
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// gameover.vue?c03b5bb0